import { render, staticRenderFns } from "./InformedConsentEdit.vue?vue&type=template&id=f1ca446c&"
import script from "./InformedConsentEdit.vue?vue&type=script&lang=js&"
export * from "./InformedConsentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports